/* eslint-disable no-invalid-this */
import axios from 'axios';

const TOKEN_EXPIRE_BEFORE = 1 * 60;
const TIME_OUT = 70 * 1000;

/**
 * リクエストマネージャ
 */
class RequestManager {
  /**
   *Creates an instance of RequestManager.
   * @memberof RequestManager
   */
  constructor() {
    this.keycloak = null;
  }

  /**
   *keycloakのセッター
   *
   * @param {*} keycloak
   * @memberof RequestManager
   */
  setKeycloak = (keycloak) => {
    this.keycloak = keycloak;
  };

  logout = () => {
    try {
      const uri = new URL(window.location.href);
      const { protocol = '', host = '' } = uri;
      const redirectUri = `${protocol}//${host}/reserve/login`;
      this.keycloak.logout({ redirectUri });
    } catch {
      window.alert('ログアウトに失敗しました。');
    }
  };

  /**
   *アクセストークンの更新
   *
   * @return {Promise<string>}
   * @memberof RequestManager
   */
  updateToken = async () => {
    if (this.keycloak === null) return null;

    const token = await this.keycloak
      .updateToken(TOKEN_EXPIRE_BEFORE)
      .then((refreshed) => {
        const { token: accessToken } = this.keycloak;
        return accessToken;
      })
      .catch((err) => {
        console.log(err);
        window.alert('アクセスに失敗しました。再ログインしてください。');
        this.logout();
        return null;
      });

    return token;
  };

  /**
   *POSTリクエスト
   *
   * @param {string} url
   * @param {json} params
   * @return {json} レスポンス
   * @memberof RequestManager
   */
  post = async (url, params) => {
    const accessToken = await this.updateToken();

    const headers = {
      // Authorization: `Bearer ${store.getState().login.accessToken}`,
      Authorization: `Bearer ${accessToken}`,
      // 'X-Authorization': `Bearer ${accessToken}`,
    };

    const config = {
      headers,
      timeout: TIME_OUT,
    };

    try {
      const response = await axios.post(url, params, config);
      return response;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        window.alert('アクセスに失敗しました。再ログインしてください。');
        this.logout();
      }
      throw err;
    }
  };

  /**
   *GETリクエスト
   *
   * @param {string} url
   * @param {json} params
   * @return {json} レスポンス
   * @memberof RequestManager
   */
  get = async (url, params = {}) => {
    const accessToken = await this.updateToken();

    const headers = {
      // Authorization: `Bearer ${store.getState().login.accessToken}`,
      Authorization: `Bearer ${accessToken}`,
      // 'X-Authorization': `Bearer ${accessToken}`,
    };

    const config = {
      headers,
      timeout: TIME_OUT,
      params,
    };

    try {
      const response = await axios.get(url, config);
      return response;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        window.alert('アクセスに失敗しました。再ログインしてください。');
        this.logout();
      }
      throw err;
    }
  };

  /**
   * PUTリクエスト
   *
   * @param {string} url
   * @param {json} data
   * @return {json} レスポンス
   * @memberof RequestManager
   */
  put = async (url, data) => {
    const accessToken = await this.updateToken();

    const headers = {
      // Authorization: `Bearer ${store.getState().login.accessToken}`,
      Authorization: `Bearer ${accessToken}`,
      // 'X-Authorization': `Bearer ${accessToken}`,
    };

    const config = {
      headers,
      timeout: TIME_OUT,
    };

    try {
      const response = await axios.put(url, data, config);
      return response;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        window.alert('アクセスに失敗しました。再ログインしてください。');
        this.logout();
      }
      throw err;
    }
  };
}

export const requestManager = new RequestManager();
// const requestManager = new RequestManager();
// export default requestManager;
